module.exports = "<div class=\"container\">\n  <br>\n  <p-growl [(value)]=\"msgs\"></p-growl>\n  <div class=\"form-row\">\n    <div class=\"form-group\"\n      *ngIf=\"(userDetails)\">\n      <div class=\"card-title\">\n        <h3>שלום {{userDetails.FirstName}} {{userDetails.LastName}}</h3>\n        \n      </div>\n    </div>\n  </div>\n  \n\n<div class=\"container\" *ngIf=\"(dataResults) && (userDetails) \">\n\n</div>\n\n"


//////////////////
// WEBPACK FOOTER
// C:/ProjectsOnGit/Pensioner/PensionerPnoCharger/PnoCharger/Client/src/app/main-page/main-page.component.html
// module id = ../../../../../src/app/main-page/main-page.component.html
// module chunks = main